import Header from "components/nav/header";
import { lazy } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, RouteObject } from "react-router-dom";
import { selectCurrentUser, selectIsLoggedIn } from "store/user/user.selector";
import { authLinks } from "utils/helper/links";
import { REDIRECT_URI } from "utils/helper/states";

const LoginPage = lazy(() => import("./login"));
const Register = lazy(() => import("./signup"));
const ResetPassword = lazy(() => import("./passwords/email"));
const VerifyAccount = lazy(() => import("./passwords/confirm"));
const WorkerSignup = lazy(() => import("routes/worker_signup/worker"));

function Authentication() {
  const isLoggedIn = useSelector(selectIsLoggedIn),
    user = useSelector(selectCurrentUser);
  const redirect = sessionStorage.getItem(REDIRECT_URI);
  const redirectURI = redirect == null ? "/" : redirect;
  if (isLoggedIn && user != null) {
    return !user.emailVerified && !user.phoneVerified ? (
      <Navigate
        to={authLinks.verify}
        replace
      />
    ) : (
      <Navigate
        to={redirectURI}
        replace
      />
    );
  }
  return isLoggedIn ? (
    <Navigate
      to={redirectURI}
      replace
    />
  ) : (
    <>
      <Header isDefault={false} />
      <Outlet />
    </>
  );
}
/**
 * "Become a service provider" sign-up. Unlike login/register it stays open
 * to a signed-in customer (who signs up a provider account); only an
 * existing provider is sent on.
 */
export function WorkerSignupPages() {
  const user = useSelector(selectCurrentUser);
  if (user?.businessName) {
    return (
      <Navigate
        to="/services"
        replace
      />
    );
  }
  return (
    <>
      <Header isDefault={false} />
      <Outlet />
    </>
  );
}

export const AuthOTPPages = () => {
  const isLoggedIn = useSelector(selectIsLoggedIn),
    user = useSelector(selectCurrentUser);
  const redirect = sessionStorage.getItem(REDIRECT_URI);
  const redirectURI = redirect == null ? "/services" : redirect;

  if (!isLoggedIn) {
    return (
      <Navigate
        to={authLinks.login}
        replace
      />
    );
  }
  return user?.emailVerified || user?.phoneVerified ? (
    <Navigate
      to={redirectURI}
      replace
    />
  ) : (
    <>
      <Outlet />
    </>
  );
};

export const authRoutes: RouteObject[] = [
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: authLinks.register,
      element: <Register />,
    },
    {
      path: authLinks.forgot_password,
      element: <ResetPassword />,
    },
  ],
  workerSignupRoutes: RouteObject[] = [
    { path: "/worker-signup", element: <WorkerSignup /> },
  ],
  authOTPRoutes: RouteObject[] = [
    {
      path: authLinks.verify,
      element: <VerifyAccount />,
    },
  ];

export default Authentication;
